import Q from 'q';

import user from 'js/lib/user';

import courseMembershipPromise from 'pages/open-course/common/promises/membership';

export const loadMembership = (actionContext: $TSFixMe, courseId: $TSFixMe) => {
  if (actionContext.getStore('CourseMembershipStore').hasLoaded()) {
    return Q();
  }

  let computedCourseId = courseId;

  if (!courseId) {
    computedCourseId = actionContext.getStore('CourseStore').getCourseId();
  }

  return courseMembershipPromise(user.get().id, computedCourseId, true).then((rawMembership: $TSFixMe) => {
    actionContext.dispatch('LOAD_COURSE_MEMBERSHIP', rawMembership);
  });
};
